import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/api/client";
import type { UserPermissionsResponse } from "@/api/types";

/**
 * Fetches the current user's permitted tabs.
 *
 * Cached for the session (staleTime: Infinity). Invalidate the
 * "userPermissions" query key to force a re-fetch — e.g. when we
 * later add a "refresh permissions" affordance.
 */
export function useUserPermissions() {
  return useQuery({
    queryKey: ["userPermissions"] as const,
    queryFn: () => apiRequest<UserPermissionsResponse>("/api/user/permissions"),
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
